import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5281a0e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "zoom-wrapper flex flex-column ion-justify-content-center ion-align-items-center"
}
const _hoisted_2 = {
  key: 1,
  class: "ion-margin-vertical"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "ion-text-center" }, "Loading Floor Map", -1))
const _hoisted_4 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderMain = _resolveComponent("HeaderMain")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_progress_bar = _resolveComponent("ion-progress-bar")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_HeaderMain, {
        "page-title": "Floor Map",
        "default-href": "/home",
        "icon-filter": false
      }),
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, {
            color: "primary",
            class: "map-toolbar"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_item, {
                lines: "none",
                class: "map-items"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_select, {
                    mode: "ios",
                    placeholder: _ctx.defaultVenueMap,
                    interface: "popover",
                    modelValue: _ctx.mapSelected,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.mapSelected) = $event)),
                    onIonChange: _ctx.onVenueMapChange
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.venueMaps, (venueMap) => {
                        return (_openBlock(), _createBlock(_component_ion_select_option, {
                          key: venueMap.id,
                          value: venueMap
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(venueMap.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["placeholder", "modelValue", "onIonChange"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("main", null, [
            (_ctx.venueMaps.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createVNode(_component_ion_icon, {
                    slot: "start",
                    icon: _ctx.addOutline,
                    onClick: _ctx.zoomIn,
                    class: "zoom-in"
                  }, null, 8, ["icon", "onClick"]),
                  _createVNode(_component_ion_icon, {
                    slot: "start",
                    icon: _ctx.removeOutline,
                    onClick: _ctx.zoomOut,
                    class: "zoom-out"
                  }, null, 8, ["icon", "onClick"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.venueMaps.length <= 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _hoisted_3,
                  _createVNode(_component_ion_progress_bar, {
                    type: "indeterminate",
                    reversed: "true"
                  })
                ]))
              : (_openBlock(), _createElementBlock("img", {
                  key: 2,
                  src: _ctx.mapSelected.url,
                  alt: _ctx.mapSelected.name,
                  class: "map-img",
                  ref: "mapImg"
                }, null, 8, _hoisted_4))
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}